export default {
  methods: {
    startCase(str) {
      // Turns kebab / snake case into start case
      if (!str || typeof str !== 'string') {
        return '';
      }
      return str.replace(/_|-/g, ' ').replace(/(?: |\b)(\w)/g, key => key.toUpperCase());
    },

    convertHtmlEntitiesToChar(str) {
      if (str == null) {
        return '';
      }
      return String(str).replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'");
    },
  },
};
